/**
 * tRPC Client Configuration
 * Sets up the tRPC client with React Query
 */
import './buffer-polyfill';
import { httpBatchLink } from '@trpc/client';
import superjson from 'superjson';

/**
 * tRPC React hooks — shared singleton from @atoncrm/api/client
 * All verticals import from the same instance so they share
 * one React Query cache and one tRPC context.
 */
export { trpc } from '@atoncrm/api/client';
import { trpc } from '@atoncrm/api/client';

/**
 * Get base URL for API
 * SEC-040 to SEC-043: Use environment variables for API URL
 * In development, use same origin to go through Vite proxy (for cookie handling)
 * In production, use same origin
 */
function getBaseUrl() {
  if (typeof window !== 'undefined') {
    // Browser - always use same origin so cookies work
    // In dev, this goes through Vite proxy (localhost:3000/trpc -> localhost:3333/trpc)
    // In prod, this goes directly to the server
    return window.location.origin;
  }
  // SSR - use API_URL env var or fall back to localhost
  return process.env.API_URL ?? `http://localhost:${process.env.API_PORT ?? 3333}`;
}

/**
 * Create tRPC client
 * SEC-030 to SEC-032: Include credentials for cookie-based authentication
 */
export function createTRPCClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${getBaseUrl()}/trpc`,
        transformer: superjson,
        // Include credentials for cookie-based authentication
        fetch: (url, options) =>
          fetch(url, { ...options, credentials: 'include' } as RequestInit),
      }),
    ],
  });
}
